/**
 * @flow
 */
'use strict';

export const confrontationVFCodes = [
    {"code":"Full"},
    {"code":"Diminished"},
    {"code":"NLP"}
]

export const autoPerimetryVFCodes = [
    {"code":"Full"},
    {"code":"Nasal step"},
    {"code":"Temporal wedge"},
    {"code":"Superior arcuate defect"},
    {"code":"Inferior arcuate defect"},
    {"code":"Tunnel vision"},
    {"code":"Enlarged blind spot"},
    {"code":"Homonymous hemianopia"},
    {"code":"Bitemporal hemianopia"},
    {"code":"Central scotoma"},
    {"code":"Centrocaecal scotoma"}
]

export const autoPerimetryInstrumentCodes = [
  {"code":"Humphrey"},
  {"code":"MRF"},
  {"code":"Medmont"},
  {"code":"Oculus"},
  {"code":"Matrix"}
]
